import { compact } from 'lodash';

export function caseInsensitiveComparator(a, b) {
    return String(a).localeCompare(b, 'en', {
        ignorePunctuation: true,
        sensitivity:       'base'
    });
}

export function toSentence(values = [], delimiter = ', ') {
    const compactValues = compact(values);
    if (!compactValues.length) {
        return '';
    }
    const [last] = compactValues.splice(compactValues.length - 1);
    if (!compactValues.length) {
        return last;
    }
    if (compactValues.length === 1) {
        return `${compactValues[0]} and ${last}`;
    }
    return `${compactValues.join(delimiter)}${delimiter}and ${last}`;
}
